<template>
  <div>
    <v-overlay :value="dataReady">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
    </center>
                  <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>

    <v-tabs v-model="tabs" fixed-tabs>
      <v-tabs-slider></v-tabs-slider>
      <v-tab id="Leave" href="#Leave" class="primary--text" > ใบลา </v-tab>
      <v-tab id="History" href="#History" class="primary--text" @click="getDataLeave()" > ประวัติ </v-tab>
      <v-tab v-if="profile.positionLevelOrderNumber > 1" id="Approve" href="#Approve" class="primary--text" @click="getDataHeaderApprove(),getDataHeaderApproveWaiting()"> อนุมัติ <v-badge
                    v-if="dataICountItemApprove>0"
                    color="red"
                    :content="dataICountItemApprove"
                  >
                  </v-badge></v-tab>
      <v-tab v-if="profile.positionLevelOrderNumber > 1" id="Verify" href="#Verify" class="primary--text"  @click="getDataHeaderVerify()"> รับทราบ </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item value="Leave">
        <!-- start -->
        <!-- </v-container> -->

        <v-container fluid>
          <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
          <!-- <form> -->

          <v-form ref="form_add" v-model="valid_add" lazy-validation>

            <v-select
              @change="calculateStartEndDate()"
              v-model="formAdd.leaveTypeCode"
              :items="itemsLeaveTypeQuota"
              :rules="nameRules"
              prepend-icon="mdi-beach"
              label="เลือก ประเภทการลา"
              clearable
              clear-icon="mdi-close-circle"
              outlined
              dense
            ></v-select>
             <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider>
            <b>
            <v-checkbox
              v-model="formAdd.leaveIssueBeforeDay"
              @click="calculateIssueBeforeDay()"
              label="ท่านต้องการใช้สิทธิ์ลาย้อนหลัง"
            ></v-checkbox>
             <!-- <v-alert
              border="top"
              colored-border
              type="warning"
              elevation="2"
              v-if="formAdd.leaveIssueBeforeDay"
            >
              ใช้สิทธิ์การลาย้อนหลังสามารถลาย้อนหลังได้ 35 วันนับจากวันปัจจุบัน
              โปรดพิจารณาห้ามเลือก หากไม่จำเป็น ระบบจะบันทึกประเภทนี้เป็นลาย้อนหลัง
            </v-alert>
             <v-alert
              border="top"
              colored-border
              type="warning"
              elevation="2"
              v-if="formAdd.leaveIssueBeforeDay"
            >
              ยกเว้น ประเภทลาป่วยสามารถใช้สิทธิ์ลาย้อนหลังได้ 3 วันนับจากวันปัจจุบันจึงไม่จำเป็นต้องเลือก ใช้สิทธิ์การลาย้อนหลัง
            </v-alert> -->
            </b>

            <!-- start date -->
            <v-divider style="background-color: #ffffff"></v-divider>
            <!-- ผู้อนุมัติลา และ รับทราบการลา -->
            <!-- <v-subheader> ผู้อนุมัติลา และ รับทราบการลา </v-subheader> -->
            <v-menu
              ref="menu"
              class="mx-1"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="auto"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formAdd.leaveStartDate"
                  @change="calculateStartEndDate()"
                  label="ตั้งแต่วันที่เริ่มต้นลา"
                  persistent-hint
                  :rules="nameRules"
                  prepend-icon="mdi-calendar"
                  clearable
                  clear-icon="mdi-close-circle"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formAdd.leaveStartDate"
                @change="calculateStartEndDate()"
                no-title
                locale="th-th"
                :min="dateMin"
                :max="dateMax"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>

            <!-- end date -->

            <!-- start date haft -->
            <v-radio-group
              v-model="formAdd.leaveStartHalf"
              mandatory
              row
              @change="calculateStartEndDate()"
            >
              <v-radio label="ช่วงเช้า" value="T" checked></v-radio>
              <v-radio label="ช่วงบ่าย" value="F"></v-radio>
            </v-radio-group>

            <!-- end date haft -->

            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formAdd.leaveEndDate"
                  @change="calculateStartEndDate()"
                  label="ถึงวันที่ สิ้นสุดลา"
                  persistent-hint
                  :rules="nameRules"
                  prepend-icon="mdi-calendar"
                  clearable
                  clear-icon="mdi-close-circle"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formAdd.leaveEndDate"
                @change="calculateStartEndDate()"
                no-title
                locale="th-th"
                :min="formAdd.leaveStartDate"
                :max="dateMax"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <v-radio-group
              v-model="formAdd.leaveEndtHalf"
              mandatory
              row
              @change="calculateStartEndDate()"
            >
              <v-radio label="ช่วงเช้า" value="F"></v-radio>
              <v-radio label="ช่วงบ่าย" value="T" checked></v-radio>
            </v-radio-group>

            <v-row>
              <v-col cols="6">
                <v-subheader>สรุปจำนวนวันลา</v-subheader>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="formAdd.leaveSummaryDay"
                  dense
                  readonly
                  outlined
                  disable
                  suffix="วัน"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider>
            <!-- ผู้อนุมัติลา และ รับทราบการลา -->
            <!-- <v-subheader> ผู้อนุมัติลา และ รับทราบการลา </v-subheader>
            <v-select
              v-model="formAdd.empCodeHeader"
              :items="dataItemHeader"
              :rules="nameRules"
              dense
              readonly
              outlined
              clear-icon="mdi-close-circle"
              prepend-icon="mdi-account-star"
              label="*ส่งอนุมัติ หัวหน้างาน"
            ></v-select>
            <v-select
              v-model="formAdd.empCodeHeaderCC1"
              :items="dataItemHeader"
              dense
              readonly
              outlined
              prepend-icon="mdi-account-star"
              label="ส่งรับทราบ หัวหน้างาน"
            ></v-select>

            <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider> -->
            <v-subheader> รายละเอียด </v-subheader>
            <v-text-field
              v-model="formAdd.leavePhoneEmergency"
              maxlength="10"
              label="เบอร์โทรศัพท์ *"
              :rules="numberRules"
              prepend-icon="mdi-cellphone"
              clear-icon="mdi-close-circle"
              clearable
              counter="10"
              outlined
              required
            ></v-text-field>
          <v-textarea
            v-model="formAdd.leaveDetail"
            maxlength="100"
            rows="3"
            row-height="25"
            outlined
            prepend-icon="mdi-message-text"
            :rules="nameRules"
            clearable
            clear-icon="mdi-close-circle"
            label="รายละเอียด"
          ></v-textarea>
          </v-form>

           <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
          <v-subheader>แนบไฟล์ 2 ไฟล์ (ทางเลือก)</v-subheader>
          <v-file-input
            v-model="files"
            show-size
            accept="image/*,.pdf"
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            :rules="imageRules"
            outlined
            dense
            required
          ></v-file-input>
          <v-file-input
            v-model="files2"
            show-size
            accept="image/*,.pdf"
            :rules="imageRules"
            outlined
            dense
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            required
          ></v-file-input>
            <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider>
             <v-alert
              border="bottom"
              colored-border
              type="warning"
              elevation="2"
            >
              การลาฉุกเฉินจะ จะไม่คิดคำนวนการลาล่วงหน้า โปรดพิจารณาการลาห้ามเลือก หากไม่จำเป็น
            </v-alert>
            <b>
            <v-checkbox
              v-model="formAdd.leaveEmergency"
              label=" ท่านต้องการลาฉุกเฉินหรือไม่"
            ></v-checkbox>
            </b>
            <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider>
        </v-container>

        <v-col class="text-right">
          <v-btn
            elevation="2"
            x-large
            color="success"
            :disabled="!valid_add"
            text
            @click="submit()"
          >
            <v-icon left>mdi-checkbox-marked-circle</v-icon>
            ส่งใบลา
          </v-btn>
        </v-col>
        <!-- </v-form> -->

        <!-- end -->
      </v-tab-item>
      <v-tab-item value="History">
                <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel
            v-for="(item,i) in itemPanel"
            :key="i"
          >
            <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
              <v-col cols="12">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                     clearable
                  clear-icon="mdi-close-circle"
                    label="เดือนที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปีที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="leaveType"
                    :items="itemsLeaveTypeSelect"
                    dense
                    outlined
                    hide-details
                    label="ประเภทลา"
                     clearable
                  clear-icon="mdi-close-circle"
                    class="ma-2"
                  ></v-select>
                  <v-btn
                    block
                    elevation="2"
                    color="info"
                    text
                    @click="getDataLeave()"
                  >
                    <v-icon left>mdi-calendar-search</v-icon>
                    ค้นหา
                  </v-btn>
              </v-col>
           </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
          <v-simple-table >
          <template v-slot:default>
          <thead>
              <tr  style="background-color: #1b437c">
                <th class="text-center">
                  รายละเอียด
                </th>
              </tr>
            </thead>
               <tbody>
                  <tr
                    v-for="item in itemsLeave"
                    :key="item.leaveId"
                  >
                    <td>
                      <a @click="getDataReport(item), dialog=true">ผู้ขอ : {{item.empFull_NameTH}} </a> <br>
                      ประเภท : <b>{{ item.quotaLeaveName }}</b><br>
                      ตั้งแต่วันที่ : <b>{{ item.leaveStartDate }}</b>
                      ถึงวันที่ : <b>{{ item.leaveEndDate }}</b><br>
                      จำนวนวันลา : {{ item.leaveSummaryDay }}
                      <br>
                       รายละเอียดการลา : {{ item.leaveDetail }}<br>
                       หมายเหตุ : {{ item.leaveRemark }}<br>
                      <!-- {{item.leaveFile}} -->
                      <a :href="item.leaveFile"  target="_blank" download v-if="item.leaveFile">
                        <b>[File Download]</b>
                      </a>
                      <br>
                      <a :href="item.leaveFile2"  target="_blank" download v-if="item.leaveFile2">
                        <b>[File Download2]</b>
                      </a>
                          <v-btn
                            color="warning"
                            class="ma-2"
                            small
                            dark
                            v-if="item.leaveEmergency === 'True'"
                          >
                            <v-icon>mdi-alert</v-icon> ลาด่วน
                          </v-btn>
                          <v-btn
                            color="gray"
                            class="ma-2"
                            small
                            dark
                          >
                           <v-icon v-if="item.leaveStatusName === 'รออนุมัติ'">mdi-clock</v-icon> {{item.leaveStatusName}}
                          </v-btn>
                      </td>
                  </tr>
                </tbody>
          </template>
           </v-simple-table>
      </v-tab-item>

      <v-tab-item value="Approve">

        <v-tabs v-model="tabsHeaer" fixed-tabs>
      <v-tabs-slider></v-tabs-slider>
      <v-tab id="request_waiting" href="#request_waiting" class="primary--text" >  <v-icon>mdi-clock</v-icon>รออนุมัติ </v-tab>
      <v-tab id="approve_history" href="#approve_history" class="primary--text"  >  <v-icon>mdi-file-document</v-icon>ประวัติ </v-tab>
    </v-tabs>

        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel
            v-for="(item,i) in itemPanel"
            :key="i"
          >
            <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
              <v-col cols="12">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                     clearable
                  clear-icon="mdi-close-circle"
                    label="เดือนที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปีที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="leaveType"
                    :items="itemsLeaveTypeSelect"
                    dense
                    outlined
                    hide-details
                    label="ประเภทลา"
                     clearable
                  clear-icon="mdi-close-circle"
                    class="ma-2"
                  ></v-select>
                  <v-text-field
                    label="ชื่อพนักงาน"
                    v-model="employeeName"
                      clearable
                  clear-icon="mdi-close-circle"
                    outlined
                    counter="100"
                    maxlength="30"
                    required
                  ></v-text-field>
                  <v-btn
                    block
                    elevation="2"
                    color="info"
                    text
                    @click="getDataHeaderApprove(),getDataHeaderApproveWaiting()"
                  >
                    <v-icon left>mdi-calendar-search</v-icon>
                    ค้นหา
                  </v-btn>
              </v-col>
           </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

 <v-tabs-items v-model="tabsHeaer">
      <v-tab-item value="request_waiting">
        <v-simple-table>
          <template v-slot:default>
          <thead>
              <tr  style="background-color: #1b437c">
                <th class="text-center">
                  รายละเอียด
                </th>
                <th class="text-center">
                  สถานะ
                </th>
              </tr>
            </thead>
               <tbody>
                  <tr
                    v-for="item in dataItemApproveWaiting"
                    :key="item.leaveId"
                  >
                    <td>
                      <a @click="getDataReport(item), dialog=true">ผู้ขอ : {{item.empFull_NameTH}} </a><br>
                      ประเภท : <b>{{ item.quotaLeaveName }}</b><br>
                      ตั้งแต่วันที่ : {{ item.leaveStartDate }} <br>
                      ถึงวันที่ : {{ item.leaveEndDate }}<br>
                      จำนวนวันลา : {{ item.leaveSummaryDay }}
                      <br v-if="item.leaveFile">
                       <a :href="item.leaveFile"  target="_blank" download v-if="item.leaveFile">
                        <b>ไฟล์แนบ : [File Download]</b>
                      </a>
                      <br v-if="item.leaveFile2">
                       <a :href="item.leaveFile2"  target="_blank" download v-if="item.leaveFile2">
                        <b>ไฟล์แนบ : [File Download]</b>
                      </a>
                      </td>
                    <td>
                      <v-btn
                            v-if="(item.leaveStatus == 'waiting')"
                            color="red"
                            class="ma-2"
                            small
                            dark
                            @click="getInfo(item)"
                          >
                           <v-icon>mdi-alert</v-icon> จัดการ
                          </v-btn>
                          <v-btn
                          v-if="(item.leaveStatus == 'approve')"
                           color="red"
                            small
                            dark
                            elevation="2"
                            @click="getInfo(item)"
                          >
                            ยกเลิกวันลา
                          </v-btn>
                      </td>
                  </tr>
                </tbody>
          </template>
        </v-simple-table>
        </v-tab-item>
      <v-tab-item value="approve_history">
        <v-simple-table>
          <template v-slot:default>
          <thead>
              <tr  style="background-color: #1b437c">
                <th class="text-center">
                  รายละเอียด
                </th>
                <th class="text-center">
                  สถานะ
                </th>
              </tr>
            </thead>
               <tbody>
                  <tr
                    v-for="item in dataItemApprove"
                    :key="item.leaveId"
                  >
                    <td>
                      <a @click="getDataReport(item), dialog=true">ผู้ขอ : {{item.empFull_NameTH}} </a><br>
                      ประเภท : <b>{{ item.quotaLeaveName }}</b><br>
                      ตั้งแต่วันที่ : {{ item.leaveStartDate }} <br>
                      ถึงวันที่ : {{ item.leaveEndDate }}<br>
                      จำนวนวันลา : {{ item.leaveSummaryDay }}
                      <br v-if="item.leaveFile">
                       <a :href="item.leaveFile"  target="_blank" download v-if="item.leaveFile">
                        <b>ไฟล์แนบ : [File Download]</b>
                      </a>
                      <br v-if="item.leaveFile2">
                       <a :href="item.leaveFile2"  target="_blank" download v-if="item.leaveFile2">
                        <b>ไฟล์แนบ : [File Download]</b>
                      </a>
                      </td>
                    <td>
                      <!-- {{item.leaveStatus}} -->
                      <v-btn
                            v-if="(item.leaveStatus == 'waiting')"
                            color="info"
                            class="ma-2"
                            small
                            dark
                            @click="getInfo(item)"
                          >
                            จัดการ
                          </v-btn>
                          <v-btn
                          v-if="(item.leaveStatus == 'approve')"
                           color="red"
                            small
                            dark
                            elevation="2"
                            @click="getInfo(item)"
                          >
                            ยกเลิกวันลา
                          </v-btn>
                          <v-btn
                          v-if="(item.leaveStatus == 'unapprove')"
                            dark
                            small
                            elevation="2"
                          >
                            ไม่อนุมัติ
                          </v-btn>
                      </td>
                  </tr>
                </tbody>
          </template>
        </v-simple-table>
        </v-tab-item>
          </v-tabs-items>
      </v-tab-item>
      <v-tab-item value="Verify">
        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel
            v-for="(item,i) in itemPanel"
            :key="i"
          >
            <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
              <v-col cols="12">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                     clearable
                  clear-icon="mdi-close-circle"
                    label="เดือนที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปีที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="leaveType"
                    :items="itemsLeaveTypeSelect"
                    dense
                    outlined
                    hide-details
                    label="ประเภทลา"
                     clearable
                  clear-icon="mdi-close-circle"
                    class="ma-2"
                  ></v-select>
                  <v-text-field
                    label="ชื่อพนักงาน"
                    v-model="employeeName"
                      clearable
                  clear-icon="mdi-close-circle"
                    outlined
                    counter="100"
                    maxlength="30"
                    required
                  ></v-text-field>
                  <v-btn
                    block
                    elevation="2"
                    color="info"
                    text
                    @click="getDataHeaderVerify()"
                  >
                    <v-icon left>mdi-calendar-search</v-icon>
                    ค้นหา
                  </v-btn>
              </v-col>
           </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-simple-table>
          <template v-slot:default>
          <thead>
              <tr  style="background-color: #1b437c">
                <th class="text-center">
                  รายละเอียด
                </th>
                <th class="text-center">
                  สถานะ
                </th>
              </tr>
            </thead>
               <tbody>
                  <tr
                    v-for="item in dataItemVerify"
                    :key="item.leaveId"
                  >
                    <td>
                     <a @click="getDataReport(item), dialog=true">ผู้ขอ : {{item.empFull_NameTH}} </a><br>
                      ประเภท : <b>{{ item.quotaLeaveName }}</b><br>
                      ตั้งแต่วันที่ : {{ item.leaveStartDate }} <br>
                      ถึงวันที่ : {{ item.leaveEndDate }}<br>
                      จำนวนวันลา : {{ item.leaveSummaryDay }}
                      <br v-if="item.leaveFile">
                       <a :href="item.leaveFile"  target="_blank" download v-if="item.leaveFile">
                        <b>ไฟล์แนบ : [File Download]</b>
                      </a>
                      <br v-if="item.leaveFile2">
                       <a :href="item.leaveFile2"  target="_blank" download v-if="item.leaveFile2">
                        <b> ไฟล์แนบ : [File Download]</b>
                      </a>
                      </td>
                    <td>
                          <v-btn
                            color="gray"
                            class="ma-2"
                            small
                            dark
                          >
                            {{item.leaveStatusName}}
                          </v-btn>
                      </td>
                  </tr>
                </tbody>
          </template>
        </v-simple-table>
      </v-tab-item>
    </v-tabs-items>
        <v-dialog v-model="dialog"
         fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      >

        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>ข้อมูล {{dataItemEmployee.empFull_NameTH}}</v-toolbar-title>
        </v-toolbar>

          <v-card>
            <v-card-title>
              <span class="headline">รายงานยอดรวม</span>
            </v-card-title>
            <v-simple-table>
              <template v-slot:default>
              <thead>
                  <tr  style="background-color: #1b437c">
                    <th class="text-center">
                      ประเภทลา
                    </th>
                    <th class="text-center">
                      จำนวนลา /วัน
                    </th>
                  </tr>
                </thead>
                  <tbody>
                      <tr
                        v-for="item in dataItemReport"
                        :key="item.quotaLeaveName"
                      >
                        <td class="text-center">
                          {{item.quotaLeaveName}}
                          </td>
                        <td class="text-center">
                          {{item.Total}}
                          </td>
                      </tr>
                    </tbody>
              </template>
            </v-simple-table>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogApprove">
          <v-card>
            <v-card-title>
              <span class="headline">หมายเหตุ</span>
            </v-card-title>
             <v-card-text>
              <v-textarea
                v-model="formUpdate.leaveRemark"
                maxlength="100"
                rows="3"
                row-height="25"
                outlined
                :rules="nameRules"
                clearable
                clear-icon="mdi-close-circle"
                label="หมายเหตุ"
              ></v-textarea>
               </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                color="dark darken-1"
                text
                @click="dialogApprove = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>

                          <v-btn
                           v-if="(formUpdate.leaveStatus == 'waiting')"
                            color="red"
                            elevation="2"
                            dark
                            @click="approve(formUpdate, 'unapprove')"
                          >
                            ไม่อนุมัติ
                          </v-btn>
                           <v-btn
                           v-if="(formUpdate.leaveStatus == 'waiting')"
                            color="success"
                            elevation="2"
                            dark
                            @click="approve(formUpdate, 'approve')"
                          >
                            อนุมัติ
                          </v-btn>
                          <v-btn
                           v-if="(formUpdate.leaveStatus == 'approve')"
                           color="red"
                            elevation="2"
                            dark
                            @click="approve(formUpdate, 'cancel')"
                          >
                            ยกเลิกวันลา
                          </v-btn>
                          <v-btn
                          v-if="(formUpdate.leaveStatus == 'unapprove')"
                            dark
                            elevation="2"
                          >
                            ไม่อนุมัติ
                          </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
export default {
  components: {},
  name: 'LeavePrivilege',
  data () {
    return {
      value: null,
      tabs: 'Leave',
      tabsHeaer: 'request_waiting',
      dateMax: moment().endOf('year').format('YYYY-MM-DD'),
      dateMin: moment().subtract(2, 'd').format('YYYY-MM-DD'),
      dateNow: moment().format('YYYY-MM-DD'),
      menu: false,
      modal: false,
      menu1: false,
      profile: [],
      itemPanel: 1,
      panel: [],
      // leaveStartHalf: null,
      // leaveEndtHalf: null,
      itemsLeave: [],
      itemsLeaveQuota: [],
      itemsLeaveSelect: [],
      itemsLeaveTypeQuota: [],
      itemsLeaveTypeSelect: [],
      itemsQuota: [],
      dataItemHeader: [],
      dataItemEmployee: [],
      profileHeader: [],
      profileHeaderCC: [],
      dataItemHeaderSelect: [],
      dataItemApprove: [],
      dataItemApproveWaiting: [],
      dataItemVerify: [],
      dataItemReport: [],
      dataICountItemApprove: 0,
      dataBtnFlow: [],
      year: '',
      month: '',
      leaveType: '',
      employeeName: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      dialog: false,
      dialogApprove: false,
      valid_add: true,
      required: {
        type: Boolean,
        default: false
      },
      center: {},
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      formUpdate: {
        leaveRemark: '-'
      },
      formAdd: {
        leaveId: '',
        leaveCode: '',
        leaveStartDate: moment().format('YYYY-MM-DD'), // วันลาเริ่มต้น
        leaveStartDay: moment().format('D'), // วันลาเริ่มต้น วัน
        leaveStartMonth: moment().format('M'), // วันลาเริ่มต้น เดือน
        leaveStartYear: moment().format('YYYY'), // วันลาเริ่มต้น ปี
        leaveStartHour: '', // วันลาเริ่มต้น ชั่วโมง
        leaveStartHalf: 'T', // วันลาเริ่มต้น ครึ่งวัน
        leaveEndDate: moment().format('YYYY-MM-DD'), // วันลาถึงวันที่
        leaveEndDay: moment().format('D'), // วันลาถึงวันที่ วัน
        leaveEndMonth: moment().format('M'), // วันลาถึงวันที่ เดือน
        leaveEndYear: moment().format('YYYY'), // วันลาถึงวันที่ ปี
        leaveEndHour: '', // วันลาถึงวันที่ ชั่วโมง
        leaveEndtHalf: 'T', // วันลาถึงวันที่ ครึ่งวัน
        empCode: '',
        empCodeHeader: null, // ส่งมอบคนที่1
        empCodeHeaderCC1: null, // ส่งมอบคนที่2
        leaveStatus: '',
        leaveDetail: '-', // รายละเอียด
        leaveRemark: '',
        leavePhoneEmergency: '', // เบอร์ติดต่อฉุกเฉิน
        leaveSummaryDay: 1, // จำนวนวันลา
        leaveTypeCode: null, // ประเภทการลา
        quotaLeaveName: '',
        moning1: '', // เช้าวันที่ลา
        after1: '', // บ่ายวันที่ลา
        moning2: '', // เช้าวันที่ลา,
        after2: '', // บ่ายวันที่ลา
        leaveFile: '',
        leaveFile2: '',
        leaveEmergency: false,
        leaveIssueBeforeDay: false
      },
      files: null,
      files2: null,
      imageUrlleve: '',
      select: '',
      sumLeave: 0,
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      imageRules: [
        value => !value || value.size < 2000000 || 'size should be less than 2 MB!'
      ],
      nameRules: [(v) => !!v || 'Input is required']
    }
  },
  async mounted () {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.formAdd.leavePhoneEmergency = JSON.parse(localStorage.getItem('liff_info')).empTel
    this.year = moment().format('YYYY')
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/HomeSpecialRequest')
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    getInfo (item) {
      this.formUpdate = []
      console.log('item', item)
      this.dialogApprove = true
      this.formUpdate = item
      this.formUpdate.leaveRemark = '-'
    },
    async getData () {
      this.dataReady = true
      // await this.getEmployeeHeader()
      await this.getEmployeeApprovePermission()
      await this.getDataLeave()
      await this.getDataLeaveQuota()
      await this.getDataLeaveType()
      if (this.profile.positionLevelOrderNumber > 1) {
        await this.getDataHeaderApproveWaiting()
        await this.getDataHeaderApprove()
        await this.getDataHeaderVerify()
      }
      this.dataReady = false
      this.clearSearch()
    },
    async calculateStartEndDate () {
      var given = moment(this.formAdd.leaveStartDate, 'YYYY-MM-DD')
      var current = moment(this.formAdd.leaveEndDate, 'YYYY-MM-DD')

      var sumDay = moment.duration(current.diff(given)).asDays() + 1

      sumDay = this.formAdd.leaveStartHalf === 'F' ? sumDay - 0.5 : sumDay
      sumDay = this.formAdd.leaveEndtHalf === 'F' ? sumDay - 0.5 : sumDay
      this.formAdd.leaveSummaryDay = sumDay

      if (sumDay <= 0) {
        // this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
        this.formAdd.leaveSummaryDay = 0
      }
      if (
        this.formAdd.leaveStartDate === null ||
        this.formAdd.leaveEndDate === null
      ) {
        this.formAdd.leaveSummaryDay = 0
      }

      // console.log(sumDay)

      this.getDataSummaryLeave(this.formAdd.leaveTypeCode)
    },
    async calculateIssueBeforeDay () {
      // console.log('calculateIssueBeforeDay')
      //  dateMin: moment().subtract(2, 'd').format('YYYY-MM-DD')
      // console.log(moment().subtract(2, 'd').format('YYYY-MM-DD'))
      // console.log(moment().subtract(35, 'd').format('YYYY-MM-DD'))
      this.dateMin = moment().subtract(35, 'd').format('YYYY-MM-DD')
    },
    async getDataLeave () {
      // Clear Data ทุกครั้ง

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.year = (this.year) ? this.year : moment().format('YYYY')

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&createMonth=' + this.getMonthThToINT(this.month) : ''

      var url = '/leave_data/getByEmp?empCode=' +
            this.profile.empCode + '&leavePrivilege=T&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch

      // console.log('url', url)
      this.itemsLeave = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsLeave = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.itemsLeave = []
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataLeaveQuota () {
      // Clear Data ทุกครั้ง
      this.itemsLeaveQuota = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/getByEmpWaitingApprove?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsLeaveQuota = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataSummaryLeave (leaveTypeCode) {
      // Clear Data ทุกครั้ง
      var sumLeave = 0
      var leaveCode = ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/quotaLeaveCode?quotaLeaveCode=' +
            leaveTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // console.log('quo', response.data)
          sumLeave = response.data.quotaLeave
          leaveCode = response.data.quotaLeaveCode
          // this.imageUrlleve = response.data.leaveImgUrl
          this.itemsLeaveSelect = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/getByEmpNotInCancel?empCode=' +
            this.profile.empCode +
            '&leaveStartYear=' +
            moment().format('YYYY') +
            '&leaveTypeCode=' +
            leaveTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // console.log('response.data.length', response.data)
          // console.log('leaveCode', leaveCode)
          var countLeave = 0
          response.data.find((d) => {
            if (d.leaveTypeCode === leaveCode) {
              countLeave += d.leaveSummaryDay
            }
          })
          // console.log('str', countLeave)
          sumLeave -= countLeave
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      // console.log('sumLeave', sumLeave)
      this.sumLeave = sumLeave
    },
    async getDataLeaveType () {
      // Clear Data ทุกครั้ง
      this.itemsLeaveTypeQuota = []
      this.itemsLeaveTypeSelect = []
      this.itemsQuota = []
      this.formAdd.leaveTypeCode = ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'position_lavel_get?positionTypeCode=' +
            this.profile.positionTypeCode + '&leavePrivilege=T',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsQuota = []
          if (response.data) {
            let rs = response.data
            // console.log('getDataLeaveType', rs)
            this.itemsQuota = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              var dropdown = {}

              dropdown.text = d.quotaLeaveName
              // console.log(s.text)
              dropdown.value = d.quotaLeaveCode
              this.itemsLeaveTypeSelect.push(dropdown)

              // this.itemsLeave.length
              var sum = 0
              if (this.itemsLeaveQuota.length > 0) {
                let quoSum = 0
                let quoLimit = 0
                this.itemsLeaveQuota.forEach((element) => {
                  if (d.quotaLeaveCode === element.leaveTypeCode) {
                    quoSum += element.leaveSummaryDay
                    quoLimit = d.quotaLeave
                  } else {
                    quoLimit = d.quotaLeave
                  }
                })

                sum = quoLimit - quoSum
              } else {
                sum = d.quotaLeave
              }
              s.text = d.quotaLeaveName + ' ( ' + sum + '/ ' + d.quotaLeave + ') วัน'
              // console.log(s.text)
              s.value = d.quotaLeaveCode
              s.quotaLeaveName = d.quotaLeaveName
              s.quota = sum
              s.quotaLeave = d.quotaLeave
              s.leaveOptioneAttached = d.leaveOptioneAttached
              s.leaveConditionAfterDay = d.leaveConditionAfterDay
              this.itemsLeaveTypeQuota.push(s)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataQuota () {
      // Clear Data ทุกครั้ง
      this.itemsQuota = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/leave_quota/get?leavePrivilege=T",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          // console.log(rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s = d.quotaLeaveName
            s.value = d.quotaLeaveName
            s.text = d.quotaLeaveName
            this.itemsQuota.push(s)
          }
          // console.log('getDataitemsQuota : ', this.itemsQuota)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataHeaderApprove () {
      this.dataItemApprove = []
      this.panel = []
      // this.dataICountItemApprove = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.year = (this.year) ? this.year : moment().format('YYYY')
      this.employeeName = (this.employeeName) ? this.employeeName : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&createMonth=' + this.getMonthThToINT(this.month) : ''
      var employeeName = (this.employeeName !== null) ? '&empFull_NameTH=' + this.employeeName : ''

      var urlHeader = '/leave_data/getByEmpHeader?empCodeHeader=' +
            this.profile.empCode + '&leavePrivilege=T&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + employeeName
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + urlHeader
        )
        .then((response) => {
          if (response.data) {
            this.dataReady = false

            this.dataItemApprove = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataHeaderApproveWaiting () {
      this.dataItemApproveWaiting = []
      this.panel = []
      this.dataICountItemApprove = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.year = (this.year) ? this.year : moment().format('YYYY')
      this.employeeName = (this.employeeName) ? this.employeeName : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&createMonth=' + this.getMonthThToINT(this.month) : ''
      var employeeName = (this.employeeName !== null) ? '&empFull_NameTH=' + this.employeeName : ''

      var urlHeader = '/leave_data/getByEmpHeaderWaiting?empCodeHeader=' +
            this.profile.empCode + '&leavePrivilege=T&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + employeeName
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + urlHeader
        )
        .then((response) => {
          this.dataReady = false
          // this.dataICountItemApprove = response.data.length

          var rs = response.data.map((item) => {
            if (item.leaveStatus === 'waiting' && typeof item !== 'undefined') {
              return item
            }
          }
          )
          var data = rs.filter(function (element) {
            return element !== undefined
          })
          this.dataICountItemApprove = data.length
          this.dataItemApproveWaiting = response.data
          // console.log('dataItemApprove', this.dataItemApprove)

          if (data.length > 0) {
            this.tabs = 'Approve'
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataItemApprove = []
          this.dataReady = false
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataHeaderVerify () {
      // console.log('getDataHeaderVerify')
      this.dataItemVerify = []
      this.dataReady = false

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.year = (this.year) ? this.year : moment().format('YYYY')
      this.employeeName = (this.employeeName) ? this.employeeName : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&createMonth=' + this.getMonthThToINT(this.month) : ''
      var employeeName = (this.employeeName !== null) ? '&empFull_NameTH=' + this.employeeName : ''

      var urlHeader = '/leave_data/getByEmpHeader?empCodeVerify=' +
            this.profile.empCode + '&leavePrivilege=T&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + employeeName

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + urlHeader
        )
        .then((response) => {
          // console.log('test', response.data)
          // this.dataReady = false
          this.dataItemVerify = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataItemVerify = []
          this.dataReady = false
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataReport (item) {
      this.dataItemEmployee = []
      this.dataItemEmployee = item

      this.dataItemReport = []

      this.month = (this.month) ? this.month : null

      var monthSearch = (this.month !== null) ? '&createMonth=' + this.getMonthThToINT(this.month) : ''

      var url = '/leave_data/getByEmpReport?empCode=' +
            item.empCode + '&leavePrivilege=T&leaveStartYear=' +
            this.year + monthSearch

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then((response) => {
          // console.log('getDataReport', response.data)
          this.dataItemReport = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataItemReport = []
          console.log(error)
        })
    },
    // async getEmployeeHeader () {
    //   this.dataItemHeader = []
    //   await axios
    //     .get(
    //       // eslint-disable-next-line quotes
    //       this.DNS_IP + "/employee/" + "getHeader",
    //       {
    //         headers: {
    //           'Application-Key': localStorage.getItem('ApplicationKey')
    //         }
    //       }
    //     )
    //     .then(async (response) => {
    //       let rs = response.data
    //       // console.log(rs)
    //       for (var i = 0; i < rs.length; i++) {
    //         var d = rs[i]
    //         var s = {}
    //         // s = d.empFull_NameTH
    //         s.value = d.empCode
    //         s.text = d.empFull_NameTH
    //         this.dataItemHeader.push(s)
    //       }
    //       // console.log('getDatadataItemHeader : ', this.dataItemHeader)
    //     })
    //     // eslint-disable-next-line handle-callback-err
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    async getEmployeeApprovePermission () {
      this.formAdd.empCodeHeader = null
      this.formAdd.empCodeHeaderCC1 = null
      // var message = 'คำเตือน : ไม่พบข้อมูลหัวหน้าของท่าน ระบบไม่สามารถส่งการแจ้งเตือนได้ กรุณาติดต่อฝ่ายบุคคล'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/approve_permission/get?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.formAdd.empCodeHeader = response.data[0].empCodeApprove
          this.formAdd.empCodeHeaderCC1 = response.data[0].empCodeVerify
          this.profileHeader.userLineuserId = response.data[0].userLineuserId_approve
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.formAdd.empCodeHeader = null
          this.formAdd.empCodeHeaderCC1 = null
          console.log(error)
        })
    },
    async approve (item, status) {
      var statusName = (status === 'approve') ? 'อนุมัติ' : (status === 'unapprove') ? 'ไม่อนุมัติ' : 'ยกเลิก'

      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dialogApprove = false
          this.dataReady = true
          let ds = {
            leaveStatus: status,
            leaveRemark: item.leaveRemark,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/leave_data/editLine/" + item.leaveId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              await this.setUpBeforeSendLineApproveUnapprove(item, status)
              await this.getData()
              this.dataReady = false
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = false
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)
          this.form_update.inputFile.value = null
          this.form_update.inputFile2.value = null

          this.dataReady = true
        })
    },
    async submit () {
      this.dataReady = false
      this.valid_add = false
      // ดึงข้อมูลโควต้า โดย รหัสประเภทโควต้า

      if (this.files) {
        await this.fileupload()
      }
      if (this.files2) {
        await this.fileupload2()
      }
      console.log('1')
      var quota = await this.getDataQuotaByName(this.formAdd.leaveTypeCode)
      // เงือนไขการลาฉุกเฉิน และ แนบไฟล์ และ โควต้าการลา  และ ลาย้อนหลัง
      console.log('2')
      var condition = await this.checkOptionCondition(this.formAdd, quota)
      // ตรวจสอบวันซ้ำ
      console.log('3')
      var checkDateDup = await this.checkDateDup(this.formAdd)
      if (condition && checkDateDup === false) {
        console.log('4')
        // await this.getDataEmpHeaderCC(this.formAdd.empCodeHeaderCC1)
        await this.setUpApprove()
      }
    },
    async getDataQuotaByName (leaveTypeCode) {
      return axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/leave_quota/quotaLeaveCode?quotaLeaveCode=" + leaveTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
    },
    // ตรวจสอบวันลาซ้ำ
    checkDateDup (formAdd) {
      var check = false
      var d = []
      this.itemsLeaveQuota.forEach(element => {
        var s = ''
        // console.log('formAdd.leaveStartDate', formAdd.leaveStartDate)
        // console.log('formAdd.leaveEndDate', formAdd.leaveEndDate)
        // console.log('element.leaveStartDate', element.leaveStartDate)
        s = this.dateCheck(formAdd.leaveStartDate, formAdd.leaveEndDate, element.leaveStartDate)
        // console.log('c', s)
        d.push(s)
      })

      check = d.includes(true)
      if (check) {
        this.$swal({
          html: 'พบวันลาซ้ำ กรุณาตรวจสอบวันลาใหม่ของท่านในวันที่ ' + formAdd.leaveStartDate + ' ถึง ' + formAdd.leaveEndDate,
          type: 'question',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ใช่'
        })
        this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
      }

      return check
    },
    // เงือนไขการลาฉุกเฉิน และ แนบไฟล์ ลาย้อนหลัง
    checkOptionCondition (formAdd, quota) {
      var check = true
      var textError1 = ''
      var textError2 = ''
      var textError3 = ''
      var now = moment(formAdd.leaveStartDate)
      // console.log('now', now)
      var end = moment(new Date()).format('YYYY-MM-DD') // todays date
      // console.log('end', end)
      var day = now.diff(end, 'days')
      var isTrueSet = (quota.data.leaveOptionBack === 'True')
      // ลาฉุกเฉิน
      if (!formAdd.leaveEmergency) {
        // ลาย้อนหลัง
        // ย้อนหลัง 35 วัน
        console.log('leaveConditionAfterDay ', quota.data.leaveConditionAfterDay)
        if (!formAdd.leaveIssueBeforeDay) {
          // ย้อนหลังตามโควต้า
          if (isTrueSet === false) {
            if (day < quota.data.leaveConditionAfterDay) {
              check = false
              textError1 = '- เงื่อนไขการลา ' + quota.data.quotaLeaveName + 'ต้องล่วงหน้าอย่างน้อย ' + quota.data.leaveConditionAfterDay + ' วัน <br>'
            }
          }
        }

        if (formAdd.leaveFile === '' && quota.data.leaveOptioneAttached === 'T') {
          check = false
          textError2 = '- กรุณาแนบไฟล์การลา  <br>'
        }
      }
      // console.log('this.sumLeave', this.sumLeave)
      // console.log('formAdd.leaveSummaryDay', formAdd.leaveSummaryDay)
      if (this.sumLeave < formAdd.leaveSummaryDay) {
        check = false
        textError3 = '- โควต้าการลา ' + quota.data.quotaLeaveName + ' ไม่เพียงพอ'
      }

      if (check === false) {
        this.$swal({
          html: 'กรุณาตรวจสอบดังนี้  <br> ' + textError1 + textError2 + textError3,
          type: 'question',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ใช่'
        })
        this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
      }
      // console.log('day < ', day)
      console.log('check ', check)
      return check
    },
    dateCheck (from, to, check) {
      let fDate, lDate, cDate
      fDate = moment(from).format('YYYY-MM-DD')
      lDate = moment(to).format('YYYY-MM-DD')
      cDate = moment(check).format('YYYY-MM-DD')
      if ((cDate <= lDate && cDate >= fDate)) return true
      return false
    },
    async setUpApprove () {
      let ds = {
        empCode: this.profile.empCode,
        userLineuserId: this.profile.userLineuserId,
        leaveStartDate: this.formAdd.leaveStartDate,
        leaveStartDay: moment(this.formAdd.leaveStartDate).format('DD'),
        leaveStartMonth: moment(this.formAdd.leaveStartDate).format('MM'),
        leaveStartYear: moment(this.formAdd.leaveStartDate).format('YYYY'),
        leaveStartHalf: this.formAdd.leaveStartHalf,
        leaveEndDate: this.formAdd.leaveEndDate,
        leaveEndDay: moment(this.formAdd.leaveEndDate).format('DD'),
        leaveEndMonth: moment(this.formAdd.leaveEndDate).format('M'),
        leaveEndYear: moment(this.formAdd.leaveEndDate).format('YYYY'),
        leaveEndtHalf: this.formAdd.leaveEndtHalf,
        empCodeHeader: this.formAdd.empCodeHeader,
        userLineuserIdHeader: this.profileHeader.userLineuserId,
        empCodeHeaderCC1: this.formAdd.empCodeHeaderCC1,
        // userLineuserIdHeaderCC: this.profileHeaderCC.userLineuserId,
        leaveDetail: this.formAdd.leaveDetail,
        leavePhoneEmergency: this.formAdd.leavePhoneEmergency,
        leaveSummaryDay: this.formAdd.leaveSummaryDay,
        leaveTypeCode: this.formAdd.leaveTypeCode,
        leaveStatus: 'waiting',
        leaveFile: this.formAdd.leaveFile,
        leaveFile2: this.formAdd.leaveFile2,
        leaveEmergency: this.formAdd.leaveEmergency,
        leaveIssueBeforeDay: this.formAdd.leaveIssueBeforeDay
      }
      console.log('addData', ds)
      this.addData(ds)
    },
    async getDataEmpHeader (empCode) {
      this.profileHeader = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user/getEmpCode?empCode=" + empCode
        )
        .then(async (response) => {
          // console.log('getDataEmpHeader', response.data)
          this.profileHeader = response.data
          // return response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataEmpHeaderCC (empCode) {
      this.profileHeaderCC = []
      if (empCode) {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/system_user/getEmpCode?empCode=" + empCode
          )
          .then(async (response) => {
            this.profileHeaderCC = response.data
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
          })
      }
    },
    async addData (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/leave_data/add",
          ds,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          await this.setUpBeforeSendLine(ds)
          await this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error leave_data : ', error)
        })
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          type: 'flex',
          altText: this.profile.empFull_NameTH + '[ขอ' + this.itemsLeaveSelect.quotaLeaveName + ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: this.itemsLeaveSelect.leaveImgUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        'คำขออนุมัติ ' + this.itemsLeaveSelect.quotaLeaveName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'รออนุมัติ',
                      wrap: true,
                      align: 'center',
                      size: '26px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: this.profile.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'เริ่มวันที่ ' +
                        item.leaveStartDate +
                        ' ถึง ' +
                        item.leaveEndDate,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'จำนวนวันลา ' + item.leaveSummaryDay + ' วัน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ ' + moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-YKeLVJoP'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      await this.setlineUser(item, payload)
      // await this.setlineUser(item, payload, payloadCC)
      this.dataReady = false
      await this.liffcloseWindow()
    },
    async setUpBeforeSendLineApproveUnapprove (item, status) {
      var statusmessage = 'อนุมัติ'
      var color = '017305'
      if (status === 'unapprove') {
        statusmessage = 'ไม่อนุมัติ'
        color = '800305'
      }
      if (status === 'cancel') {
        statusmessage = 'ยกเลิก'
        color = '800305'
      }
      var payload = [
        {
          type: 'flex',
          altText: item.empFull_NameTH + '[' + statusmessage + item.quotaLeaveName + ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: item.leaveImgUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        'คำขออนุมัติ ' + item.quotaLeaveName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: statusmessage,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'เริ่มวันที่ ' +
                        item.leaveStartDate +
                        ' ถึง' +
                        item.leaveEndDate,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'จำนวนวันลา ' + item.leaveSummaryDay + ' วัน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ ' + moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    }
                  ],
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      await this.setlineUser(item, payload)
      this.dataReady = false
      // }
      // await this.liffcloseWindow()
    },
    async setlineUser (item, payload) {
      if (item.userLineuserId) {
        await this.sendLinePush(payload, item.userLineuserId)
      }
      if (item.userLineuserIdHeader) {
        await this.sendLinePush(payload, item.userLineuserIdHeader)
      }
      // if (item.userLineuserIdHeaderCC) {
      //   await this.sendLinePush(payloadCC, item.userLineuserIdHeaderCC)
      // }
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt, {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
    },
    async liffcloseWindow () {
      await this.$liff.closeWindow()
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.profile)
      console.log('this.files', _this.files)
      console.log('this.files', _this.files.size)
      console.log(_this.DNS_IP_UPLOAD + '/upload')

      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Leave'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.leaveFile = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.leaveFile = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files = null
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()

      if (_this.files2.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files2)
        params.append('profile', _this.profile)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Leave'
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.leaveFile2 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.leaveFile2 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files2 = null
        }

        console.log('this.files2', _this.formAdd.leaveFile2)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files2 = null
      }
    },
    clearSearch () {
      this.leaveType = null
      this.month = null
      this.employeeName = null
      this.files = null
      this.files2 = null
      this.formAdd.leaveFile = null
      this.formAdd.leaveFile2 = null
      this.formAdd.leaveEmergency = false
      this.formAdd.leaveIssueBeforeDay = false
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
 /* .v-text-field{
      width: 400px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Liff/LeavePrivilege.vue